'use client';

import {setPageViewContextProvider} from '@/lib/appInsights';
import {store} from '@/lib/UserFlow';

setPageViewContextProvider(() => {
    const {user} = store.getSnapshot().context;
    const props: Record<string, string> = {};
    if (user.userUid) props.userUid = user.userUid;
    if (user.nfcTagUid) props.nfcTagUid = user.nfcTagUid;
    return props;
});

export default function PageViewContextProvider() {
    return null;
}
